import gsap from '../../../gsap-public/esm/index.js';

class PageTransitions {
  constructor() {
    this.overlay = document.querySelector('[data-transition-overlay]');
    this.bindLinks();
    this.transitionIn();
  }

  bindLinks() {
    // Portfolio cards
    const portfolioLinks = document.querySelectorAll('.portfolio-card__link');
    portfolioLinks.forEach(link => {
      link.addEventListener('click', (e) => this.handleTransition(e));
    });

    // Back links
    const backLinks = document.querySelectorAll('[data-back-link]');
    backLinks.forEach(link => {
      link.addEventListener('click', (e) => this.handleTransition(e));
    });

    // Next project links
    const nextLinks = document.querySelectorAll('[data-next-project]');
    nextLinks.forEach(link => {
      link.addEventListener('click', (e) => this.handleTransition(e));
    });
  }

  handleTransition(e) {
    e.preventDefault();
    const url = e.currentTarget.href;

    this.transitionOut(() => {
      window.location.href = url;
    });
  }

  transitionOut(callback) {
    if (!this.overlay) {
      this.overlay = document.createElement('div');
      this.overlay.className = 'page-transition';
      this.overlay.setAttribute('data-transition-overlay', '');
      document.body.appendChild(this.overlay);
    }

    const tl = gsap.timeline({
      onComplete: callback
    });

    tl.set(this.overlay, {
      display: 'block',
      scaleX: 0,
      transformOrigin: 'left'
    });

    tl.to(this.overlay, {
      scaleX: 1,
      duration: 0.6,
      ease: 'power4.inOut'
    });
  }

  transitionIn() {
    if (!this.overlay) return;

    // If overlay is visible (navigated from another page), wipe it away
    gsap.set(this.overlay, {
      display: 'block',
      scaleX: 1,
      transformOrigin: 'right'
    });

    gsap.to(this.overlay, {
      scaleX: 0,
      duration: 0.6,
      ease: 'power4.inOut',
      delay: 0.1,
      onComplete: () => {
        gsap.set(this.overlay, { display: 'none' });
      }
    });
  }
}

export default PageTransitions;
